import { Input } from "@/components/ui/input";
import { FieldWrapper } from "@/forms/field-wrapper";
import { useFormContext } from "react-hook-form";

export function PasswordField({
  field,
  disabled = false,
  shouldRenderLabel = true,
  onChange = () => {},
  labelClassName = undefined,
}: FormField) {
  const { control } = useFormContext();

  return (
    <FieldWrapper
      field={field}
      control={control}
      disabled={disabled}
      shouldRenderLabel={shouldRenderLabel}
      labelClassName={labelClassName}
      renderComponent={(formField) => (
        <Input
          {...formField}
          onChange={(event) => {
            formField.onChange(event);
            onChange(event);
          }}
          name={field.name}
          id={field.name}
          type={"password"}
        />
      )}
    />
  );
}
